/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import injectSheet, { createUseStyles } from 'react-jss'
import { compose, lifecycle } from 'recompose'
import { connect, useDispatch } from 'react-redux'
import InfoIcon from '@mui/icons-material/Info'
import Paper from '@mui/material/Paper'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Chart from 'chart.js'

import Tooltip from '@mui/material/Tooltip'
import { useOutletContext } from 'react-router-dom'
import { selectReport } from '../../../../redux/selectors'
import { fetchListingStatsReports } from '../../../../redux/actions'
import { formatDate, formatDateTime, formatTime } from '../../../../formatting'
import ListingGraph from './ListingGraph'

const useStyles = createUseStyles({
  title: {
    display: 'flex',
    alignItems: 'center',
    margin: '0px',
    padding: '5px 0px 20px',
    fontSize: '20px',
  },
  infoIcon: {
    marginLeft: '7px',

    '&:hover ~ $tooltip': {
      opacity: 1,
    },
  },
  tooltip: {
    cursor: 'default',
    pointerEvents: 'none',
    opacity: 0,
  },
})

export function OverviewTab() {
  const { verificationListing: listing } = useOutletContext()
  const classes = useStyles()
  const formatTimestampLabels = (lines, reportId) => {
    switch (reportId) {
      case 'listing30':
        return lines.map((l) => formatDate(l.timestamp))
      case 'listingDay':
        return lines.map((l) => formatDateTime(l.timestamp))
      case 'listingHour':
        return lines.map((l) => formatTime(l.timestamp))
      default:
        return 'todo: format new line type'
    }
  }
  const dispatch = useDispatch()
  const getListingStatsReports = () => dispatch(fetchListingStatsReports(listing?.id))

  useEffect(() => {
    if (listing?.id) {
      getListingStatsReports()
    }
  }, [listing?.id])

  if (!listing) {
    return null
  }

  return (
    <Paper style={{ position: 'relative', padding: '20px 30px 0px', margin: '3px' }}>
      <Typography variant="h2" className={classes.title}>
        Authorizations
        <Tooltip title="An authorization is an approved access grant for your listing" placement="right">
          <InfoIcon className={classes.infoIcon} />
        </Tooltip>
      </Typography>
      <Divider style={{
        marginLeft: '-30px', marginRight: '-30px', marginTop: '5px', marginBottom: '25px',
      }}
      />
      <ListingGraph
        formatTimestampLabels={formatTimestampLabels}
        listingId={listing.id}
        reportId="listing30"
        title="Last 30 days"
      />
    </Paper>
  )
}

export default OverviewTab
